import React, { PureComponent } from 'react'
import { withRouter } from 'react-router'
import NotFoundTemplate from './NotFoundTemplate'

// import { RouteComponentProps } from 'react-router-dom'

class NotFound extends PureComponent {
  componentDidMount() {
    setTimeout(() => {
      this.props.history.push('/')
    }, 1500)
  }

  render() {
    return <NotFoundTemplate />
  }
}

export default withRouter(NotFound)
